import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, BarChart3 } from "lucide-react";
import ec from "@/i18n/ec.json";

// Spanish-only Thank You page (no i18n context needed - fixed language)
const ThankYou = () => {
  const t = (path) => {
    const parts = path.split(".");
    let cur = ec;
    for (const p of parts) {
      cur = cur?.[p];
    }
    return typeof cur === "string" ? cur : path;
  };

  return (
    <div
      data-testid="thank-you-page"
      className="min-h-screen bg-slate-950 text-white flex flex-col relative overflow-hidden"
    >
      <div className="absolute inset-0 grid-pattern-dark opacity-40 pointer-events-none" />

      <header className="relative bg-slate-900 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center">
          <Link to="/" className="flex items-center gap-2" data-testid="thank-you-header-logo">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded bg-emerald-500/15 border border-emerald-500/30">
              <BarChart3 className="w-4 h-4 text-emerald-400" strokeWidth={2.4} />
            </span>
            <span className="font-display text-xl font-bold text-white">{t("brand.name")}</span>
          </Link>
        </div>
      </header>

      <main className="relative flex-1 flex items-center justify-center px-6 py-24">
        <div className="max-w-2xl w-full text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-emerald-500/15 border border-emerald-500/40 mb-8">
            <CheckCircle2 className="w-10 h-10 text-emerald-400" strokeWidth={2} />
          </div>
          <div className="eyebrow eyebrow-dark mb-4">{t("thanks.eyebrow")}</div>
          <h1
            data-testid="thank-you-message"
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight"
          >
            {t("thanks.title")}
          </h1>
          <p className="text-lg text-slate-300 leading-relaxed mb-4">
            {t("thanks.message")}
          </p>
          <p className="text-sm text-slate-400 italic mb-10">{t("thanks.note")}</p>
          <Link
            to="/"
            data-testid="thank-you-back-home"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-emerald-500 text-slate-900 font-semibold hover:bg-emerald-400"
          >
            <ArrowLeft className="w-4 h-4" />
            {t("thanks.back")}
          </Link>
        </div>
      </main>

      <footer className="relative bg-slate-950 border-t border-slate-800 py-6">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center text-xs text-slate-500">
          {t("footer.copyright")}
        </div>
      </footer>
    </div>
  );
};

export default ThankYou;
